import { LucideIcon } from "lucide-react";
import { useInView } from "../../util/useInView";

// posições dos 4 conceitos, em % da caixa (viewBox 400 x 400)
const NODES = [
  { x: 22, y: 16 },
  { x: 78, y: 16 },
  { x: 22, y: 84 },
  { x: 78, y: 84 },
];

const CENTER = 200;

// curva do conceito até o centro, saindo na vertical
const linkPath = ({ x, y }: { x: number; y: number }) => `M ${x * 4} ${y * 4} Q ${x * 4} ${CENTER} ${CENTER} ${CENTER}`;

type SolutionExplainerProps = {
  icon: LucideIcon;
  label: string;
  concepts: readonly string[];
};

// Diagrama animado do "O que é": o ícone da solução no centro e os 4 conceitos ligados a ele. Ao aparecer na tela,
// as ligações se desenham, o centro surge e os conceitos entram um a um; depois pontos rosa correm até o centro.
export default function SolutionExplainer({ icon: Icon, label, concepts }: SolutionExplainerProps) {
  const [ref, state] = useInView<HTMLDivElement>(0.3);

  return (
    <div ref={ref} className={`cz-explainer${state}`} role="img" aria-label={`${label}: ${concepts.join(", ")}`}>
      <svg className="cz-explainer__links" viewBox="0 0 400 400" aria-hidden="true">
        <circle className="cz-explainer__orbit" cx={CENTER} cy={CENTER} r="118" />
        {NODES.map((node, i) => (
          <g key={i} style={{ "--i": i } as React.CSSProperties}>
            <path className="cz-explainer__link" d={linkPath(node)} pathLength={1} />
            <path className="cz-explainer__flow" d={linkPath(node)} pathLength={1} />
          </g>
        ))}
      </svg>

      <div className="cz-explainer__center" aria-hidden="true">
        <span className="cz-explainer__pulse" />
        <span className="cz-explainer__core">
          <Icon size={40} strokeWidth={1.5} />
        </span>
      </div>

      {concepts.slice(0, NODES.length).map((concept, i) => (
        <span
          key={concept}
          className="cz-explainer__node"
          style={{ left: `${NODES[i].x}%`, top: `${NODES[i].y}%`, "--i": i } as React.CSSProperties}
          aria-hidden="true"
        >
          <span className="cz-explainer__dot" />
          {concept}
        </span>
      ))}
    </div>
  );
}
